import { Box, Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { useNavigate } from "react-router-dom";
import { Input, LocalShipping, Logout, QrCodeScanner, ZoomIn, Pageview, Rule } from "@mui/icons-material";

const Home = () => {
    const navigate = useNavigate();

    const widgets = [
        {
            title: "Lager",
            widgets: [
                {
                    title: "Sendungserfassung",
                    description: "Neue Sendungen annehmen und erfassen.",
                    icon: <LocalShipping fontSize="large" />,
                    path: "/checkin"
                },
                {
                    title: "Einlagerung",
                    description: "Ein- und Umlagerungen erfassen.",
                    icon: <Input fontSize="large" />,
                    path: "/storage"
                },
                {
                    title: "Umetikettierung",
                    description: "Neu zugeordnete Sendungen umetikettieren.",
                    icon: <Rule fontSize="large" />,
                    path: "/relabel"
                },
                {
                    title: "Zustell-PIN Verwaltung",
                    description: "Zustell-PINs abfragen und hinterlegen.",
                    icon: <Rule fontSize="large" />,
                    path: "/pinexchange"
                },
            ]
        },
        {
            title: "Lagerverwaltung",
            widgets: [
                {
                    title: "Inventur",
                    description: "Inventur starten und Berichte aufrufen.",
                    icon: <QrCodeScanner fontSize="large" />,
                    path: "/inventur"
                },
                {
                    title: "Warehouse",
                    description: "Lageransicht und Suchfunktionen für das Warehouse.",
                    icon: <WarehouseOutlinedIcon fontSize="large" />,
                    path: "/warehouse"
                },
                {
                    title: "Warehouse Optimize",
                    description: "Lagerstruktur und Wege gezielt optimieren.",
                    icon: <TuneOutlinedIcon fontSize="large" />,
                    path: "/warehouse/optimize"
                }
            ]
        },
        {
            title: "Kasse",
            widgets: [
                {
                    title: "Sendungsausgabe",
                    description: "Sendungen ausgeben und Vorgänge an der Kasse abwickeln.",
                    icon: <Logout fontSize="large" />,
                    path: "/checkout"
                }
            ]
        },
        {
            title: "Recherche",
            widgets: [
                {
                    title: "Recherche",
                    description: "Recherche- und Auskunftsfunktionen schnell erreichen.",
                    icon: <ZoomIn fontSize="large" />,
                    path: "/recherche"
                },
                {
                    title: "Suchaufträge",
                    description: "Suchaufträge erstellen und bearbeiten.",
                    icon: <Rule fontSize="large" />,
                    path: "/claims"
                }
            ]
        }
    ];

    return (
        <Box
            sx={{
                px: { xs: 2, md: 4 },
                py: { xs: 4, md: 6 }
            }}
        >


            <Box sx={{ display: "flex", flexDirection: "column", gap: 5 }}>
                {widgets.map((group) => (
                    <Box key={group.title}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
                            {group.title}
                        </Typography>

                        <Grid container spacing={2}>
                            {group.widgets.map((widget) => (
                                <Grid item xs={12} sm={6} lg={4} key={widget.path}>
                                    <Card
                                        variant="outlined"
                                        sx={{
                                            height: "100%",
                                            borderRadius: 3,
                                            transition: "all 0.2s ease",
                                            "&:hover": {
                                                boxShadow: 3,
                                                transform: "translateY(-2px)"
                                            }
                                        }}
                                    >
                                        <CardActionArea
                                            onClick={() => navigate(widget.path)}
                                            sx={{
                                                height: "100%",
                                                alignItems: "stretch"
                                            }}
                                        >
                                            <CardContent sx={{ p: 2 }}>
                                                <Box
                                                    sx={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        width: 52,
                                                        height: 52,
                                                        borderRadius: 2,
                                                        backgroundColor: "action.hover",
                                                        mb: 2
                                                    }}
                                                >
                                                    {widget.icon}
                                                </Box>

                                                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                                                    {widget.title}
                                                </Typography>

                                                <Typography variant="body2" color="text.secondary">
                                                    {widget.description}
                                                </Typography>
                                            </CardContent>
                                        </CardActionArea>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default Home;